module.exports = __webpack_public_path__ + "img/health29_7-9-2021.580bd520.jpg";